import React, { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import NavBar from "../NavBar/NavBar.tsx";
import Help from "../Help Section/Help.js";
import Footer from "../Footer/Footer.tsx";
import OurServicesSection from "../OurServicesSection/OurServicesSection.tsx";
import ScrollToTopButton from "../Common-component/ScrollToTopButton.tsx";
import { serviceBannerImg, serviceBannerImg1, serviceBannerImg2 } from "../../Assets.tsx";

/* Colours: text #4e5356 | buttons #2596be | headings #4573a6 | background white
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body) */

const hotAreas = [
  { title: "Games", text: "Engaging game experiences built for mobile.", icon: <><rect x="2" y="7" width="20" height="11" rx="4" /><path d="M7 10v5M4.5 12.5h5M16 11h.01M18.5 14h.01" /></> },
  { title: "Location Tracking / GPS", text: "Real-time location and tracking solutions.", icon: <><path d="M12 21s7-6.2 7-11.5A7 7 0 005 9.5C5 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></> },
  { title: "Social Media", text: "Connected apps that bring people together.", icon: <><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0113 0M16 4.5a3.5 3.5 0 010 7M18 14.5a6.5 6.5 0 013.5 5.5" /></> },
  { title: "Business", text: "Apps that help you market and serve your business.", icon: <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M9 7V4h6v3M3 13h18" /></> },
];

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.sv{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;background:#fff;font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text)}
.sv-in{display:flex;align-items:center;justify-content:space-between;gap:70px;max-width:1240px;margin:0 auto}
.sv-in.rev{flex-direction:row-reverse}
.sv-sec{padding:70px 24px}
.sv-center{text-align:center;max-width:880px;margin:0 auto}

.sv-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase}
.sv h1,.sv h2{margin:0 0 16px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:var(--head);cursor:default;transition:color .35s,letter-spacing .35s}
.sv h1:hover,.sv h2:hover{color:var(--btn);letter-spacing:.6px}
.sv-sec h2{font-size:34px}
.sv h3.sv-sub{margin:0 0 18px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;color:var(--head)}
.sv-line{display:flex;align-items:center;gap:12px;margin-bottom:20px}
.sv-center .sv-line{justify-content:center}
.sv-line i{display:block;height:2px;width:40px;border-radius:2px;background:var(--btn)}.sv-line i:last-child{background:var(--head)}
.sv p{margin:0 0 16px;font-size:14.5px;line-height:1.75;color:var(--text)}
.sv p b{font-family:"Ubuntu",sans-serif;font-weight:700;color:var(--head)}
.sv-text{flex:1;min-width:0;max-width:580px}

.rv{opacity:0;transform:translateY(46px);transition:opacity .8s cubic-bezier(.2,.8,.2,1),transform .8s cubic-bezier(.2,.8,.2,1);transition-delay:var(--d,0s)}
.rv.in{opacity:1;transform:none}

.sv-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:8px;padding:12px 28px;border:none;border-radius:50px;
  background:var(--tint);color:var(--head);font-family:"Open Sans",sans-serif;font-weight:600;font-size:14px;cursor:pointer;box-shadow:0 0 0 1px var(--line) inset;
  transition:color .35s,transform .35s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.sv-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.sv-btn:hover{color:#fff;transform:translateY(-3px);box-shadow:0 16px 26px -12px rgba(37,150,190,.7)}
.sv-btn:hover::before{transform:none}
.sv-btn span{display:inline-block;transition:transform .35s}
.sv-btn:hover span{transform:translateX(5px)}

.sv-tags{display:flex;flex-wrap:wrap;gap:10px;margin:22px 0 30px}
.sv-center .sv-tags{justify-content:center;margin:8px 0 0}
.sv-tag{position:relative;overflow:hidden;z-index:0;padding:7px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);color:var(--head);
  font-size:14px;font-weight:600;cursor:default;transition:color .35s,border-color .35s,transform .35s cubic-bezier(.3,1.6,.5,1)}
.sv-tag::before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,var(--head),var(--btn));transform:translateY(101%);transition:transform .4s cubic-bezier(.2,.8,.2,1)}
.sv-tag:hover{color:#fff;border-color:transparent;transform:translateY(-3px)}
.sv-tag:hover::before{transform:none}

/* hero */
.sv-hero{padding:150px 24px 80px}
.sv-hero .sv-text{animation:svR .9s cubic-bezier(.2,.8,.2,1) backwards}
.sv-vis{position:relative;flex:none;width:48%;max-width:560px;animation:svL .9s .15s cubic-bezier(.2,.8,.2,1) backwards}
.sv-ring{position:absolute;inset:-14px;border-radius:44px;overflow:hidden}
.sv-ring::before{content:"";position:absolute;left:50%;top:50%;width:200%;height:200%;margin:-100% 0 0 -100%;
  background:conic-gradient(from 0deg,#4573a6,#2596be,#a9d3e6,#4573a6);animation:svSpin 8s linear infinite}
.sv-ring::after{content:"";position:absolute;inset:4px;border-radius:40px;background:#fff}
.sv-tilt{position:relative;padding:28px;border-radius:32px;background:#fff;border:1px solid var(--line);box-shadow:0 30px 50px -26px rgba(69,115,166,.5);
  transition:transform .15s ease-out;transform:perspective(900px) rotateX(0) rotateY(0)}
.sv-tilt img{display:block;width:100%;height:auto;object-fit:contain}
.sv-chipf{position:absolute;z-index:3;display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:16px;background:#fff;
  border:1px solid var(--line);box-shadow:0 18px 30px -16px rgba(69,115,166,.55);font-size:13px;color:var(--text);white-space:nowrap}
.sv-chipf b{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:15px;color:var(--head)}
.sv-chipf .dot{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;background:linear-gradient(135deg,var(--head),var(--btn))}
.sv-chipf.c1{left:-34px;bottom:44px;animation:svFloat 5s ease-in-out infinite}
.sv-chipf.c2{right:-24px;top:34px;animation:svFloat 6s -2s ease-in-out infinite}

/* image card */
.sv-img{position:relative;flex:none;width:42%;max-width:480px}
.sv-img::before{content:"";position:absolute;inset:-18px 18px 18px -18px;border-radius:32px;background:var(--tint);border:1px solid var(--line)}
.sv-in.rev .sv-img::before{inset:-18px -18px 18px 18px}
.sv-img img{position:relative;display:block;width:100%;height:auto;object-fit:contain;padding:22px;border-radius:32px;background:#fff;border:1px solid var(--line);
  box-shadow:0 30px 50px -26px rgba(69,115,166,.5);transition:transform .5s cubic-bezier(.3,1.4,.5,1)}
.sv-img:hover img{transform:translateY(-8px)}

/* hot-area cards */
.sv-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:22px;max-width:1240px;margin:56px auto 0}
.sv-card{--mx:50%;--my:50%;--rx:0deg;--ry:0deg;position:relative;overflow:hidden;height:100%;text-align:center;padding:36px 22px 30px;border-radius:24px;
  background:#fff;border:1px solid var(--line);box-shadow:0 18px 36px -26px rgba(69,115,166,.55);
  transform:perspective(900px) rotateX(var(--rx)) rotateY(var(--ry));transition:transform .18s ease-out,box-shadow .4s,border-color .4s}
.sv-card:hover{border-color:transparent;box-shadow:0 30px 50px -22px rgba(37,150,190,.7)}
.sv-glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;
  background:radial-gradient(240px circle at var(--mx) var(--my),rgba(37,150,190,.16),rgba(69,115,166,.05) 45%,transparent 70%)}
.sv-card:hover .sv-glow{opacity:1}
.sv-top{position:absolute;top:0;left:0;width:100%;height:5px;transform:scaleX(0);transform-origin:left;background:linear-gradient(90deg,var(--head),var(--btn));transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.sv-card:hover .sv-top{transform:scaleX(1)}
.sv-icon{position:relative;width:80px;height:80px;margin:0 auto 20px;border-radius:24px;background:var(--tint);display:flex;align-items:center;justify-content:center;
  transition:background .4s,box-shadow .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.sv-icon svg{width:34px;height:34px;fill:none;stroke:var(--head);stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;transition:stroke .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.sv-card:hover .sv-icon{background:linear-gradient(135deg,var(--head),var(--btn));transform:translateY(-6px);box-shadow:0 10px 22px -8px rgba(37,150,190,.6)}
.sv-card:hover .sv-icon svg{stroke:#fff;transform:scale(1.1)}
.sv-card h3{position:relative;display:inline-block;margin:0 0 12px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;color:var(--head)}
.sv-card h3::after{content:"";position:absolute;left:0;bottom:-5px;height:2px;width:0;background:var(--btn);transition:width .45s cubic-bezier(.2,.8,.2,1)}
.sv-card:hover h3::after{width:100%}
.sv-card p{position:relative;margin:0}

/* who are we stat */
.sv-stat{display:inline-block;margin:6px 0 26px;padding:22px 44px;border-radius:24px;background:#fff;border:1px solid var(--line);box-shadow:0 18px 36px -26px rgba(69,115,166,.55);
  transition:transform .4s cubic-bezier(.3,1.4,.5,1),box-shadow .4s,border-color .4s}
.sv-stat:hover{transform:translateY(-8px);border-color:rgba(37,150,190,.5);box-shadow:0 30px 50px -22px rgba(37,150,190,.6)}
.sv-stat strong{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:36px;line-height:1.1;color:var(--head)}
.sv-stat span{font-size:14.5px}

@keyframes svL{from{opacity:0;transform:translateX(-70px)}}
@keyframes svR{from{opacity:0;transform:translateX(70px)}}
@keyframes svSpin{to{transform:rotate(360deg)}}
@keyframes svFloat{50%{transform:translateY(-12px)}}

@media(max-width:1100px){.sv-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
@media(max-width:960px){
  .sv-hero{padding:120px 18px 60px}
  .sv-in,.sv-in.rev{flex-direction:column;gap:56px}
  .sv-text{max-width:100%}
  .sv-vis,.sv-img{width:100%;max-width:420px}
  .sv-chipf.c1{left:-8px}.sv-chipf.c2{right:-8px}
  .sv-sec{padding:50px 18px}
}
@media(max-width:600px){
  .sv h1{font-size:30px}.sv-sec h2{font-size:28px}
  .sv-grid{grid-template-columns:1fr}
}
@media(prefers-reduced-motion:reduce){
  .sv *,.sv *::before,.sv *::after{animation:none!important;transition:none!important}
  .rv{opacity:1;transform:none}
}
`;

/* fades a block in once it scrolls into view */
const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={"rv " + className + (show ? " in" : "")} style={{ "--d": delay + "s" }}>
      {children}
    </div>
  );
};

const AreaCard = ({ item }) => {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    el.style.setProperty("--mx", x + "px");
    el.style.setProperty("--my", y + "px");
    el.style.setProperty("--ry", ((x / r.width - 0.5) * 8).toFixed(2) + "deg");
    el.style.setProperty("--rx", ((0.5 - y / r.height) * 8).toFixed(2) + "deg");
  };
  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.setProperty("--rx", "0deg");
    ref.current.style.setProperty("--ry", "0deg");
  };

  return (
    <div className="sv-card" ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave}>
      <div className="sv-top" />
      <div className="sv-glow" />
      <div className="sv-icon"><svg viewBox="0 0 24 24">{item.icon}</svg></div>
      <h3>{item.title}</h3>
      <p>{item.text}</p>
    </div>
  );
};

const ServicePage = () => {
  const history = useHistory();
  const tiltRef = useRef(null);

  // gentle 3D tilt on the hero image
  const handleMove = (e) => {
    const el = tiltRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const handleLeave = () => {
    if (tiltRef.current) tiltRef.current.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
  };

  return (
    <div>
      <NavBar />
      <style>{STYLES}</style>

      <div className="sv">
        {/* HERO */}
        <div className="sv-hero">
          <div className="sv-in rev">
            <div className="sv-text">
              <div className="sv-chip">Our Services</div>
              <h1>From Napkin Sketches To Fully Developed Spec Sheets.</h1>
              <div className="sv-line"><i /><i /></div>
              <p>
                <b>ATUM Information Technology</b> is able to meet your needs for web and mobile design,
                development, and strategy.
              </p>
              <div className="sv-tags">
                <span className="sv-tag">Web Design</span>
                <span className="sv-tag">Mobile Design</span>
                <span className="sv-tag">Development</span>
                <span className="sv-tag">Strategy</span>
              </div>
              <button className="sv-btn" onClick={() => history.push("/contact")}>
                Get Started <span>→</span>
              </button>
            </div>

            <div className="sv-vis" onMouseMove={handleMove} onMouseLeave={handleLeave}>
              <div className="sv-ring" />
              <div className="sv-tilt" ref={tiltRef}>
                <img src={serviceBannerImg} alt="ATUM services" />
              </div>
              <div className="sv-chipf c1">
                <span className="dot">✓</span>
                <div>Quality<b>Delivery</b></div>
              </div>
              <div className="sv-chipf c2">
                <span className="dot">★</span>
                <div>Client<b>First</b></div>
              </div>
            </div>
          </div>
        </div>

        {/* SERVICES OFFERED */}
        <div className="sv-sec">
          <Reveal className="sv-center">
            <div className="sv-chip">What We Do</div>
            <h2>Services Offered</h2>
            <div className="sv-line"><i /><i /></div>
            <h3 className="sv-sub">We Ensure Supreme Assistance To Our Clients!</h3>
            <p>
              Company Web App Tech focuses on quality delivery, innovation, and flexibility, which are critical
              factors in engaging our clients' target market. Our clients are our top priority; we dive deep into
              the business requirements they bring to us. Analysis and estimation of the requirements are
              continuous, so that the result is a profitable product. We are determined and committed to keeping
              up with trending technologies to meet our clients' needs. The current market prefers reliable,
              robust, and efficiently built mobile applications. When you opt for our service, our developers,
              analysts, and the entire team will surpass expectations. Our clients' chosen services are below:
            </p>
          </Reveal>
        </div>

        {/* SOFTWARE DEVELOPMENT */}
        <div className="sv-sec">
          <div className="sv-in">
            <Reveal className="sv-img">
              <img src={serviceBannerImg1} alt="Software development" />
            </Reveal>
            <Reveal className="sv-text" delay={0.12}>
              <div className="sv-chip">Development</div>
              <h2>Software Development And Analysis Of Business Requirements</h2>
              <div className="sv-line"><i /><i /></div>
              <p>
                Our determination drives us daily to adopt the technologies the market demands, and the digital
                approach is the easiest way to plan ahead. Our professionals have always focused on good
                hands-on experience in software development, which plays a vital role in clients' business
                expansion. We utilise advances in technology and digital processes to the fullest, and based on
                our analysis, we figure out the suitable technology for you.
              </p>
            </Reveal>
          </div>
        </div>

        {/* EXPERIENCE */}
        <div className="sv-sec">
          <div className="sv-in rev">
            <Reveal className="sv-img">
              <img src={serviceBannerImg2} alt="Experience" />
            </Reveal>
            <Reveal className="sv-text" delay={0.12}>
              <div className="sv-chip">Our Track Record</div>
              <h2>Experience</h2>
              <div className="sv-line"><i /><i /></div>
              <p>
                The world we live in today is changing rapidly with the advancement of digital technology, which
                is driven by authentic information, so we have come up with solutions that speak for themselves.
                Our application development services make a real difference in this fast-paced world, mainly to
                market and serve the business.
              </p>
              <p>
                We believe in teamwork: designers, developers, and testers work closely with the client from the
                first idea to the final launch of the mobile application.
              </p>
            </Reveal>
          </div>

          <Reveal className="sv-center" delay={0.05}>
            <p style={{ marginTop: 70, marginBottom: 0 }}>Hot areas we deal with:</p>
          </Reveal>
          <div className="sv-grid" style={{ marginTop: 22 }}>
            {hotAreas.map((a, i) => (
              <Reveal key={a.title} delay={i * 0.1}>
                <AreaCard item={a} />
              </Reveal>
            ))}
          </div>
        </div>

        {/* WHO ARE WE */}
        <div className="sv-sec" style={{ paddingBottom: 40 }}>
          <Reveal className="sv-center">
            <div className="sv-chip">About Us</div>
            <h2>Who Are We?</h2>
            <div className="sv-line"><i /><i /></div>
            <div className="sv-stat">
              <strong>40+</strong>
              <span>Industries Served</span>
            </div>
            <p>
              We are a well-established technology firm that goes the extra mile to meet clients' needs, mainly
              in strategy, consultation, digital technology and operations. Our exposure to more than 40
              industries, across core business functions and support functions, has equipped us with the
              challenges and hands-on experience we have had to deal with.
            </p>
            <div className="sv-tags">
              <span className="sv-tag">Strategy</span>
              <span className="sv-tag">Consultation</span>
              <span className="sv-tag">Digital Technology</span>
              <span className="sv-tag">Operations</span>
            </div>
          </Reveal>
        </div>

        <OurServicesSection />
      </div>

      {/* help */}
      <Help />
      <ScrollToTopButton />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ServicePage;